import { FILE_TYPES_META, FileType } from '@models/file';

import { resolveGraphqlBaseUrl } from './tenant-utils';
import { getUserToken } from './userUtils';

interface DownloadByPathPayload {
  path: string;
  documentName: string;
}

export function isFile(input: any) {
  if ('File' in window && input instanceof File) return true;
  else return false;
}

export function deriveMimeTypes(fileTypes?: FileType[]): string {
  if (fileTypes) {
    const extMimeTypes = fileTypes.map(
      (type) => FILE_TYPES_META[type].mimetype
    );

    return extMimeTypes.join(', ');
  }

  return '';
}

export function generateDownloadLink(
  fileId: string,
  entityTypeId: string,
  entityId: string,
  entityViewId: string,
  propertyId: string
): string {
  return `${resolveGraphqlBaseUrl()}/api/Files/download/entities?entityTypeId=${entityTypeId}&entityId=${entityId}&entityViewId=${entityViewId}&propertyId=${propertyId}&fileId=${fileId}`;
}
export function generateNewDownloadLink(documentId: string): string {
  return `${resolveGraphqlBaseUrl()}/api/Documents/download/${documentId}`;
}

export async function downloadFileFromUrl(url: string, fileName: string) {
  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${getUserToken()}`
      }
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch file from ${url}`);
    }

    // Get the file's blob
    const blob = await response.blob();

    // Create a link element
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;

    // Append the link to the body (required for Firefox)
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading the file:', error);
  }
}

export async function downloadFileByPath(
  payload: DownloadByPathPayload
): Promise<void> {
  const url = `${resolveGraphqlBaseUrl()}/api/Documents/download/path`;

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getUserToken()}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`Failed to download file: ${response.statusText}`);
    }

    const blob = await response.blob();

    const link = document.createElement('a');
    const objectUrl = window.URL.createObjectURL(blob);

    link.href = objectUrl;
    link.download = payload.documentName;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.error('Error downloading file by path:', error);
    throw error;
  }
}
